import { render, staticRenderFns } from "./GroupInfoShow.vue?vue&type=template&id=4ab97be6&"
import script from "./GroupInfoShow.vue?vue&type=script&lang=js&"
export * from "./GroupInfoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports